export default __webpack_public_path__ + "static/media/Register.a73bbd79.png";